import React from "react";
import { useTranslation } from "react-i18next";
import {
  HELP_PAGE_URL,
  PROFILE_URL,
  SCHEDULING_URL,
} from "../../utils/urlConstants";
import { GetTypographyContent } from "../shared/Typography/Typography";

export const FooterLinkInfo = (): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <>
      {GetTypographyContent({
        content: t("footer.links.aboutUs"),
        size: "small",
        link: "https://billiontoone.com/about",
        externalLink: true,
        textColor: "greenDark",
      })}
      {GetTypographyContent({
        content: t("footer.links.helpFaq"),
        size: "small",
        link: HELP_PAGE_URL,
        textColor: "greenDark",
      })}
      {GetTypographyContent({
        content: t("footer.links.profile"),
        size: "small",
        link: PROFILE_URL,
        textColor: "greenDark",
      })}
      {GetTypographyContent({
        content: t("footer.links.bookConsultation"),
        size: "small",
        link: SCHEDULING_URL,
        textColor: "greenDark",
      })}
    </>
  );
};
